<template>
  <form-box :title="$t('message.Booking.myInfo')">
    <template slot="right">
      <el-button type="primary" plain @click="$emit('onLogout')">
        {{ $t("message.Booking.logoutBtn") }}
      </el-button>
    </template>
    <div class="itnal_info_box">
      <MyCell>
        <MyCellItem :label="$t('message.Booking.applicantIdentType')" :value="$t(`message.Booking.companyType${value.applicantIdentType}`)"></MyCellItem>
        <MyCellItem :label="$t('message.Booking.applicantIdentNo')" :value="value.applicantIdentNo"></MyCellItem>
        <MyCellItem
          :label="$t('message.Booking.regAndIdNo')"
          :value="value.name"
        ></MyCellItem>
        <MyCellItem
          :label="$t('message.Booking.mobile')"
          :value="value.mobile"
        ></MyCellItem>
        <MyCellItem
          :label="$t('message.Booking.cancelable')"
          :value="value.cancelable"
        ></MyCellItem>
      </MyCell>
    </div>
  </form-box>
</template>
<script>
import FormBox from "./FormBox.vue";
import MyCell from "@/components/MyCell.vue";
import MyCellItem from "@/components/MyCellItem.vue";

export default {
  components: {
    FormBox,
    MyCell,
    MyCellItem,
  },
  props: {
    value: Object,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.itnal_info_box {
  border: 1px solid #d0d0d0;
  border-radius: 10px;
  overflow: hidden;
  margin: 16px auto;
}
</style>
